import { render, staticRenderFns } from "./TagsChipGroup.vue?vue&type=template&id=9fa76f78&scoped=true"
import script from "./TagsChipGroup.vue?vue&type=script&lang=js"
export * from "./TagsChipGroup.vue?vue&type=script&lang=js"
import style0 from "./TagsChipGroup.vue?vue&type=style&index=0&id=9fa76f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa76f78",
  null
  
)

export default component.exports